import formatBanners from './formatBanners';
import themeEditor from './themeEditor';

export default () => {
  formatBanners();
  themeEditor();
};